var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Modal, ModalFooter, Button, Icon, Loading, MultiColumnList, MessageBanner, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchProducts } from "../../api/productService";
import { assignTitleToBlockedProductNumber } from "../../api/productNumberService";
import { RecekTextField } from "../../components/inputs";
/**
 * Modal that legalizes an already blocked ISBN/ISMN by linking an existing title
 * (a product without a number) of the number's publisher to it. The agency worker
 * searches the publisher's titles by name, then picks a product that has no number
 * yet; confirming calls the assign-title endpoint, which unblocks and assigns the
 * number in one step.
 *
 * @use-case #RECEK-74773
 */
export var ProductNumberAssignTitleModal = function (_a) {
    var _b, _c, _d, _e;
    var productNumber = _a.productNumber, onClose = _a.onClose, onAssigned = _a.onAssigned, onError = _a.onError;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    // A blocked number's owning publisher may sit on the number itself or, when the
    // number was pre-generated/blocked, only on its publisher prefix — mirror the backend's
    // resolveNumberPublisherId fallback so the title search is scoped to the right publisher.
    var publisherId = (_c = (_b = productNumber.publisher) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : (_e = (_d = productNumber.publisherPrefix) === null || _d === void 0 ? void 0 : _d.publisher) === null || _e === void 0 ? void 0 : _e.id;
    var _f = useState(""), searchTerm = _f[0], setSearchTerm = _f[1];
    var _g = useState(""), appliedTerm = _g[0], setAppliedTerm = _g[1];
    var _h = useQuery(["assignTitleProducts", publisherId, appliedTerm], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!publisherId || !appliedTerm.trim()) {
                return [2 /*return*/, { items: [] }];
            }
            return [2 /*return*/, fetchProducts(ky, {
                    search: { publisher: publisherId, name: appliedTerm.trim() },
                    limit: 50,
                })];
        });
    }); }, {
        enabled: !!publisherId && !!appliedTerm.trim(),
        staleTime: 30000,
        // Only products WITHOUT a number can be legalized onto this blocked number.
        select: function (data) { var _a; return ((_a = data.items) !== null && _a !== void 0 ? _a : []).filter(function (item) { return !item.productNumber; }); },
    }), _j = _h.data, products = _j === void 0 ? [] : _j, isFetching = _h.isFetching;
    var assignMutation = useMutation(function (productId) {
        return assignTitleToBlockedProductNumber(ky, productNumber.id, productId);
    }, {
        onSuccess: function (result) { return onAssigned(result); },
        onError: function () {
            return onError(formatMessage({
                id: "ui-br-agency.product-number.assignTitle.error",
            }));
        },
    });
    var handleSearch = function () { return setAppliedTerm(searchTerm); };
    var showNoResults = !!appliedTerm.trim() && !isFetching && products.length === 0;
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { onClick: onClose, disabled: assignMutation.isLoading },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))));
    return (React.createElement(Modal, { open: true, dismissible: true, onClose: onClose, size: "medium", label: formatMessage({
            id: "ui-br-agency.product-number.assignTitle.modal.title",
        }), footer: footer },
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.hint" })),
        React.createElement("div", { style: { display: "flex", gap: "8px", alignItems: "flex-end" } },
            React.createElement("div", { style: { flex: 1 } },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assignTitle.modal.searchLabel", placeholder: formatMessage({
                        id: "ui-br-agency.product-number.assignTitle.modal.searchPlaceholder",
                    }), value: searchTerm, onChange: function (e) {
                        return setSearchTerm(e.target.value);
                    }, onKeyDown: function (e) {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch();
                        }
                    } })),
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSearch, disabled: !searchTerm.trim() || isFetching },
                React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.searchButton" }))),
        isFetching && React.createElement(Loading, null),
        showNoResults && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.noResults" }))),
        !appliedTerm.trim() && (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.searchPrompt" }))),
        products.length > 0 && (React.createElement(MultiColumnList, { contentData: products, columnMapping: {
                mainTitle: (React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.column.title" })),
                firstContributor: (React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.column.contributor" })),
                action: (React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.column.action" })),
            }, formatter: {
                mainTitle: function (item) { return item.mainTitle || "-"; },
                firstContributor: function (item) {
                    return item.firstContributor || "-";
                },
                action: function (item) { return (React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, disabled: assignMutation.isLoading, onClick: function () { return item.id && assignMutation.mutate(item.id); } }, assignMutation.isLoading ? (React.createElement(Icon, { icon: "spinner-ellipsis", size: "small" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assignTitle.modal.select" })))); },
            }, visibleColumns: ["mainTitle", "firstContributor", "action"], interactive: false }))));
};
